import type { FaireCategoryEntity } from "../../entity_types/category";

export const catalog_cat_dogs: FaireCategoryEntity = {
  token: "catalog_cat_dogs",
  type: "category",
  name: "Dogs",
  count: 3,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
